import React, { PropTypes } from 'react';
import ProjectTile from 'common/components/project_tile';

const PostedProjects = ({ items, categories, user, industries }) => {
  return (
    <div>
      { items.map(item => (
        <ProjectTile item={item} categories={categories} industries={industries}
          authenticated={!!user.id} userType={user.user_type || 'Anonymous'} key={item.id} />
      )) }
    </div>
  );
};

PostedProjects.propTypes = {
  items: PropTypes.array.isRequired,
  industries: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  user: PropTypes.object.isRequired,
};

export default PostedProjects;



// WEBPACK FOOTER //
// ./your_projects/components/posted_projects.jsx